/**
 * Public merchant category list for registration and dispatch UIs.
 * Default rows match `apps/api/database/seeders/MerchantCategorieSeeder.php`
 * so the dropdown works when the API is empty or unreachable.
 */
export const DEFAULT_MERCHANT_CATEGORIES = [
    { id: 1, name: 'RESTAURANT' },
    { id: 2, name: 'FLEURISTE' },
    { id: 3, name: 'COURRIER' },
    { id: 4, name: 'PHARMACIE' },
    { id: 5, name: 'AUTRE' },
    { id: 6, name: 'ANIMALERIE' },
    { id: 7, name: 'ÉPICERIE' },
    { id: 8, name: 'DÉPANNEUR' },
    { id: 9, name: 'BOULANGERIE-PATISSERIE' },
]

export function buildBackendApiUrl(path) {
    const base = (process.env.NEXT_PUBLIC_BACKEND_URL || '').trim().replace(/\/+$/, '')
    const segment = path.replace(/^\/+/, '')
    if (!base) return `/${segment}`
    return `${base}/${segment}`
}

export function normalizeMerchantCategory(raw) {
    if (!raw || typeof raw !== 'object') return null
    const id = raw.id ?? raw.MCATID
    const name = raw.name
    if (id == null || id === '') return null
    if (name == null || String(name).trim() === '') return null
    const n = Number(id)
    return { id: Number.isNaN(n) ? id : n, name: String(name) }
}

export function parseMerchantCategoriesBody(body) {
    if (!body) return []
    if (Array.isArray(body)) return body
    if (Array.isArray(body.data)) return body.data
    if (
        body.data &&
        typeof body.data === 'object' &&
        Array.isArray(body.data.data)
    ) {
        return body.data.data
    }
    return []
}

export async function fetchMerchantCategoriesList() {
    const url = buildBackendApiUrl('api/merchant-categories')
    try {
        const res = await fetch(url, {
            method: 'GET',
            credentials: 'omit',
            headers: { Accept: 'application/json' },
        })
        if (!res.ok) throw new Error(`HTTP ${res.status}`)
        const body = await res.json()
        const normalized = parseMerchantCategoriesBody(body)
            .map(normalizeMerchantCategory)
            .filter(Boolean)
        return normalized.length > 0 ? normalized : DEFAULT_MERCHANT_CATEGORIES
    } catch {
        return DEFAULT_MERCHANT_CATEGORIES
    }
}
